"use strict";

exports.__esModule = true;
exports.StatusHistorySection = StatusHistorySection;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _Translator = require("../../Core/Translator");
var _Core = require("../../Core");
var _moment = _interopRequireDefault(require("moment"));
var _Time = require("../../Time");
var _styles = require("./styles");
var _ticketing = require("../../Widgets/DataTable/Formatters/ticketing");
var _icons = require("@blueprintjs/icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var statusChangeHistoryHistoryProps = {
  updator: String,
  updatorId: String,
  status: String,
  timestamp: Date
};
function StatusHistorySection(props) {
  var time = _react["default"].useContext(_Time.TimeContext);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var statusChangeHistory = props.statusChangeHistory,
    _props$muted = props.muted,
    muted = _props$muted === void 0 ? false : _props$muted,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled;
  var ticketWasUpdated = statusChangeHistory.length !== 0;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    muted: muted,
    heading: translate("TicketDetails.StatusHistory.LastStatusUpdate", "Last Status Update Time"),
    content: ticketWasUpdated && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/_react["default"].createElement(_styles.StyledDateText, {
      "data-testid": "TicketDetails.StatusHistory.UpdatedAt"
    }, _moment["default"].utc(statusChangeHistory[statusChangeHistory.length - 1].timestamp).tz(time.timezone.name).format(translate("DateTimeFormat.MonthDayYearHourMinutesA", "MMM D, YYYY, hh:mm A"))), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginLeft: "10px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Popover, {
      content: !disabled && getContent(statusChangeHistory, time.timezone.name, translate),
      position: _core.Position.LEFT
    }, /*#__PURE__*/_react["default"].createElement(_styles.StyledText, {
      disabled: disabled,
      onClick: function onClick() {}
    }, translate("TicketDetails.statusHistory.button", "View History"), /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.MAXIMIZE,
      size: 12,
      style: {
        marginLeft: "3px",
        marginBottom: "2px"
      },
      "data-testid": "TicketDetails.StatusHistory.MaximizeIcon"
    })))))
  }));
}
var formatData = function formatData(data, timezoneName, translate) {
  return data.map(function (item) {
    item.status = (0, _ticketing.formatStatus)(item.status, null, translate);
    item.updatedAt = _moment["default"].utc(item.timestamp).tz(timezoneName).format(translate("DateTimeFormat.MonthDayYearHourMinutesA", "MMM D, YYYY, hh:mm A"));
    return item;
  });
};
var getColumns = function getColumns(translate) {
  return [{
    id: "updatedAt",
    name: translate("TicketDetails.StatusHistory.UpdatedAt", "Updated At"),
    type: "date",
    usePlantTime: true,
    accessor: "updatedAt",
    dateFormat: "ShortDateTime",
    defaultSortOrder: "DESC",
    canSort: true,
    useRowValue: true
  }, {
    id: "updator",
    name: translate("TicketDetails.StatusHistory.UpdatedBy", "Updated by"),
    type: "string",
    accessor: "updator",
    dateFormat: "ShortDateTime",
    canSort: true,
    canFilter: true,
    useRowValue: true
  }, {
    id: "status",
    name: translate("TicketDetails.StatusHistory.Status", "Status"),
    accessor: "status",
    type: "status",
    canSort: true,
    canFilter: true,
    useRowValue: true
  }];
};
var getContent = function getContent(statusChangeHistory, timezoneName, translate) {
  return /*#__PURE__*/_react["default"].createElement(_Core.DataTable, {
    columns: getColumns(translate),
    data: formatData(statusChangeHistory, timezoneName, translate),
    height: "400px",
    width: "400px",
    defaultPageSize: 5,
    showReloadButton: false,
    showDownloadButton: false,
    manual: true,
    filterable: true,
    noDataText: translate("TicketDetails.StatusHistory.NoDataFound", "No updates found")
  });
};